module.exports = __webpack_public_path__ + "img/Dantam Fashion 11.7fc46d77.jpg";